import { Button, ProgressBar } from "@quark/design";
import { FC, useMemo } from "react";
import { Course } from "../../../types";
import ArrowRight from "../../../icons/arrow-right";
import styles from "./index.module.scss";
import CardImg from "../../course-list/card-img";
import { useNavigate } from "react-router-dom";

interface CourseCardProps {
  dataSource: Course;
}

const CourseCard: FC<CourseCardProps> = ({ dataSource }) => {
  const navigate = useNavigate();
  const [learned, total] = useMemo(() => {
    const {
      learn_info: { page_num, learn_page_num, coach_num, learn_coach_num },
    } = dataSource;
    return [learn_page_num + learn_coach_num, page_num + coach_num];
  }, [dataSource]);

  const finishPercent = useMemo<number>(() => {
    return Math.floor((learned / total) * 100);
  }, [learned, total]);

  const buttonText = useMemo<string>(() => {
    if (finishPercent === 0) {
      return "开始学习";
      // } else if (finishPercent === 100) {
      //   return "查看证书";
    } else {
      return "继续学习";
    }
  }, [finishPercent]);

  const goTocoursePage = () => {
    // todo: 学习完成后无法进入再次学习了？
    // if (finishPercent === 100) {
    //   // 完成学习，跳转至证书页面
    //   navigate(`/course/${dataSource.course_no}/certificate`);
    // } else {
    //   // 未完成，跳转至上次学习页面
    //   navigate(`/course/${dataSource.course_no}/catalog`);
    // }
    navigate(`/course/${dataSource.course_no}/catalog`);
  };

  return (
    <div className={styles["course-card"]}>
      <CardImg src={dataSource.cover_img} />
      <div className={styles.content}>
        <div className={styles.title}>{dataSource.title}</div>
        <div className={styles.summary}>{dataSource.summary}</div>
      </div>
      <div className={styles.footer}>
        <div className={styles.left}>
          <div>{finishPercent}%</div>
          <ProgressBar current={learned} total={total} />
        </div>
        <Button onClick={() => goTocoursePage()}>
          <span>{buttonText}</span> &nbsp;
          <ArrowRight />
        </Button>
      </div>
    </div>
  );
};

export default CourseCard;
